const { demoSrcIds } = require('../../utils/assets.js');
const { genCooperateMsgs } = require('./utils.js');

module.exports = {
  ...require('./shared.js'),

  title: 'แม่รู้ดี ตรวจสอบข้อเท็จจริง แบบไว้ใจได้ ช่วยคุณเช็คข้อมูลที่น่าสงสัย ข่าวลวง',
  metaUrl: 'https://www.checkcheck.me/th',
  metaDescription:
    'จะแยกแยะ ข่าวลวงหรือข่าวลือได้อย่างไร? ช่วงนี้ได้รับคำขอเป็นเพื่อนในไลน์จากคนที่ไม่รู้จักมากขึ้น? กังวลกับการโทรเข้า จากเบอร์ที่ไม่คุ้นเคย?',
  metaImageSrc: require('./assets/demo.en/AM_web_900x452.png'),
  metaKeywords: 'fact-checking, chatbot, LINE, maeroodee',

  brandSrc: require('./assets/brand.th.svg'),
  brandAlt: 'แม่รู้ดี',
  navTitle: 'แม่รู้ดี',
  community: 'Community',
  communityHref: 'https://www.facebook.com/groups/2034059996670763',
  report: 'Report',
  reportHref:
    'https://airtable.com/shrNhn0gw3HJHaNn7',

  heroTitle: 'แม่รู้ดี',
  heroTitleMobile: 'แม่รู้ดี',
  heroSub:
    'ตรวจสอบข้อเท็จจริง แบบไว้ใจได้ ช่วยคุณเช็คข้อมูลที่น่าสงสัย ข่าวลวง',
  inviteLinebot: 'https://line.me/R/ti/p/%40maeroodee',
  heroBtn: 'เพิ่มเพื่อนทาง LINE',
  heroQrcodeSrc: require('./assets/hero-qrcode.th.svg'),
  heroQrcodeAlt: 'เพิ่มเพื่อนทาง LINE',
  owlJson: JSON.stringify(require('./assets/hero-owl.en.json')),

  introImgSrc: require('./assets/intro.en.svg'),
  introImgAlt: 'intro-img',
  introLines:
    'จะแยกแยะ ข่าวลวงหรือข่าวลือได้อย่างไร? ช่วงนี้ได้รับคำขอเป็นเพื่อนในไลน์จากคนที่ไม่รู้จักมากขึ้น? กังวลกับการโทรเข้า จากเบอร์ที่ไม่คุ้นเคย?',

  [demoSrcIds('01').x1]: require('./assets/demo.en/AM_web_900x452.png'),
  [demoSrcIds('01').x2]: require('./assets/demo.en/AM_web_1800x904.png'),
  [demoSrcIds('01').mobileX1]: require('./assets/demo.en/AM_web_750x600.png'),
  [demoSrcIds('01').mobileX2]: require('./assets/demo.en/AM_web_750x600.png'),
  demo01Title: 'เพิ่ม แม่รู้ดี ในกลุ่มแชทของคุณ!',
  demo01Description:
    'แม่รู้ดีจะอยู่ในกลุ่มแต่จะไม่ขัดจังหวะการสนทนา จะแจ้งเตือนเมื่อมีการโพสต์ข้อมูลที่น่าสงสัยเท่านั้น แม่รู้ดี จะเช็คข้อมูลเพื่อช่วยคุณแยกแยะข่าวที่ไม่น่าเชื่อ',
  [demoSrcIds('02').x1]: require('./assets/demo.en/02.png'),
  [demoSrcIds('02').x2]: require('./assets/demo.en/02@2x.png'),
  [demoSrcIds('02').mobileX1]: require('./assets/demo.en/02_mobile.png'),
  [demoSrcIds('02').mobileX2]: require('./assets/demo.en/02_mobile@2x.png'),
  demo02Title: 'ห้องแชทส่วนตัวแบบ 1 : 1',
  demo02Description:
    'ไม่ได้รับการตอบโพสต์ไหน ก็ส่งถามแม่รู้ดีในแชทส่วนตัวได้เลย ไม่ว่าจะเป็นข้อความข่าวสาร หรือ บทความ ก็ส่งไลน์ไปหา แม่รู้ดี ได้ หากยังไม่มีการรายงานข้อมูลดังกล่าว คุณสามารถส่งรายงาน พร้อมข้อมูลที่เกี่ยวข้องให้ แม่รู้ดี ตรวจเช็คได้',

  featureTitle: 'ฟังก์ชั่นของ แม่รู้ดี',
  chatCheckTitle: '<strong>เปรียบเทียบข้อมูล</strong>',
  chatCheckDescription:
    'เพียงแค่แชร์ข่าว หรือข้อมูลที่อยู่บนโซเชียลมีเดีย หรือแอปพลิเคชันรับส่งข้อความ แม่รู้ดีจะนำไปเปรียบกับแหล่งข้อมูลต่างๆ ทันที',
  chatCheckAppendix:
    '(แหล่งข้อมูลจาก ศูนย์ต่อต้านข่าวปลอม Anti-Fake News Center Thailand, Thai D.I. Machine, สำนักงานข่าว สปริงนิวส์ (Spring News), FDA-สำนักงานคณะกรรมการอาหารและยา (อย.) )',
  callCheckTitle: '<strong>เช็คเบอร์โทรศัพท์</strong>',
  callCheckDescription:
    "ถามทุกเลขหมายโทรศัพท์ แม่รู้ดีจะเช็คจากฐานข้อมูลที่ถูกบันทึกไว้ใน Whoscall กว่า 1,600 ล้านเลขหมาย ปลอดภัยจากการถูกหลอกลวงและเบอร์ที่น่าสงสัยเหล่านั้น!",
  idCheckTitle: '<strong>ตรวจสอบ LINE ID ที่ไม่คุ้นเคย</strong>',
  idCheckDescription:
    "คุณยังได้รับคำขอเป็นเพื่อนจากคนที่ไม่รู้จักอีกใช่ไหม! บอกแม่รู้ดีสิ เธอจะช่วยเช็คข้อมูลจากกรมสอบสวนอาชญากรรม เพื่อตรวจสอบ ID LINE ว่าเป็นนักต้มตุ๋นหรือไม่",
  personalInfoTitle: '<strong>ตรวจสอบข้อมูลรั่วไหล</strong>',
  personalInfoDescription:
    'ข้อมูลส่วนตัวถูกขโมยมากขึ้นบนโลกออนไลน์  และข้อมูลของคุณอาจรั่วไหลอยู่เช่นกัน เช็คอีเมลของคุณกับเว็บไซต์ตรวจสอบข้อมูลรั่วไหลที่น่าเชื่อถืออย่าง 「Have I been pwned?」คุณจะทราบในทันทีหากข้อมูลของคุณถูกโจรกรรม เพื่อแก้ปัญหาและจัดการเปลี่ยนข้อมูลการเข้ารหัสใหม่ได้ทันที',

  aboutTitle: 'เกี่ยวกับเรา',
  aboutLines:
    "แม่รู้ดี ถูกสร้างขึ้นจากวิศวกรชาวไต้หวัน Carol Hsu ในปี 2561 เริ่มต้นจากรูปแบบ LINE แชทบอท ด้วยวัตถุประสงค์เพื่อช่วยเพื่อนและครอบครัวแยกแยะข่าวที่น่าสงสัยและข่าวลือที่มักจะได้รับผ่านแอปพลิเคชันรับส่งข้อความ หลังจากได้รับการตอบรับที่ดีมาก ไม่นานบริการนี้ได้จึงถูกนำมาใช้กับสาธารณะ ปัจจุบัน แม่รู้ดี มีผู้ใช้มากกว่า 300,000 ราย\nจากปรากฎการณ์ที่ผู้คนเข้ามาใช้บริการจำนวนมาก จำเป็นต้องเพิ่มโครงสร้างพื้นฐานและการสนับสนุนด้วยเช่นกัน แม่รู้ดี จึงได้จับมือกับพันธมิตรที่น่าเชื่อถืออย่าง Gogolook ผู้พัฒนาแอปพลิเคชั่นระบุตัวตนสายเรียกเข้า Whoscall ในปี 2563 ภายใต้เป้าหมายร่วมกันในการมอบความปลอดภัยและความไว้วางใจให้กับผู้ใช้บริการ จึงได้พัฒนาบริการของแม่รู้ดีให้สามารถปกป้องประชาชนผู้ใช้ได้อย่างสมบูรณ์มากขึ้น\nปัจจุบัน แม่รู้ดี ใช้เปรียบเทียบข้อมูลจากแหล่งต่างๆ อาทิ ข้อมูลหมายเลขโทรศัพท์จาก Gogolook กรมสอบสวนอาชญากรรม เว็บไซต์ตรวจสอบข้อมูลรั่วไหลที่น่าชื่อถืออย่าง 「Have I been pwned?」แพลตฟอร์มตรวจสอบข้อมูลเช่น ศูนย์ต่อต้านข่าวปลอม Anti-Fake News Center Thailand, Thai D.I. Machine, สำนักงานข่าว สปริงนิวส์ (Spring News), FDA-สำนักงานคณะกรรมการอาหารและยา (อย.)",

  cooperatorTitle: 'พันธมิตร',
  ...genCooperateMsgs([
    {
      src: require('./assets/cooperators/ThaiFDA_logo.png'),
      alt: 'FDA',
      href: 'https://sure.oryor.com/',
    },
    {
      src: require('./assets/cooperators/AFNC_logo.png'),
      alt: 'AFNC',
      href: 'https://www.antifakenewscenter.com/',
    },
    {
      src: require('./assets/cooperators/thdim_logo.jpeg'),
      alt: 'Thai D.I. Machine',
      href: 'https://thaidimachine.org/knownFakeNews/',
    },
    {
      src: require('./assets/cooperators/springnews_logo.png'),
      alt: 'SpringNews',
      href: 'https://www.springnews.co.th/category/news/fact-check',
    },
    {
      src: require('./assets/cooperators/whoscall.png'),
      alt: 'Whoscall',
      href: 'https://whoscall.com',
    },
    {
      src: require('./assets/cooperators/pwned.svg'),
      alt: 'have i been pwned?',
      href: 'https://haveibeenpwned.com/',
    },
  ]),

  questionAnswerTitle: 'คำถามที่พบบ่อย',
  questionAnswerOpenAlt: 'Open',
  questionAnswerCloseAlt: 'Close',
  questionAnswer01Q: "Q1  ฉันไม่สามารถเชิญแม่รู้ดีเข้ากลุ่มแชทได้",
  questionAnswer01A:
    'คุณอาจมีแชทบอทบางตัวอยู่ในกลุ่มก่อนแล้ว ลองเช็คที่รายชื่อสมาชิกและลบบัญชีบอทที่มีอยู่ จากนั้นก็สามารถเพิ่ม แม่รู้ดี ในกลุ่มแชทของคุณ',
  questionAnswer02Q: "Q2  ฉันไม่ได้รับการตอบกลับจาก แม่รู้ดี",
  questionAnswer02A:
    "ในกลุ่มแชท แม่รู้ดี จะตอบสนองต่อข้อมูลที่ดูมีความน่าสงสัยเท่านั้น หากข้อมูลดังกล่าวไม่ได้รับการรายงานว่ามีความน่าสงสัย แม่รู้ดีจะไม่ตอบสนองในกลุ่มแชท",
  questionAnswer03Q: 'Q3 แม่รู้ดี จะเก็บข้อมูลของฉันหรือเปล่า',
  questionAnswer03A:
    "ไม่ แม่รู้ดี จะไม่เก็บข้อมูลของผู้ใช้ ข้อมูลทั้งหมดที่แม่รู้ดีเก็บจะอยู่ภายใต้นโยบายความเป็นส่วนตัวของ LINE แชทบอททุกตัว ไม่สามารถเก็บข้อมูลส่วนตัวของผู้ใช้ได้ ไม่ว่าจะเป็น ชื่อ หรือ เบอร์โทรศัพท์",
  questionAnswer04Q: 'Q4  แม่รู้ดี จะดักฟังการสนทนาของฉันหรือเปล่า',
  questionAnswer04A:
    'เพื่อเปรียบเทียบข้อมูลที่น่าสงสัย แม่รู้ดี จำเป็นต้องเช็คข้อความที่กำลังส่งมา และเราพยายามอย่างที่สุดในการไม่สนใจข้อมูลที่ไม่เกี่ยวข้องกับข้อความน่าสงสัยเพื่อประสบการณ์ของผู้ใช้งานที่ดีขึ้น เราเชื่อมั่นว่าความเป็นส่วนตัวของการสนทนามีความสำคัญมาก และหวังว่าผู้ใช้ทุกคนจะได้รับการแจ้งก่อนการเริ่มใช้บริการ เราคาดหวังจากใจจริงว่าผู้ใช้จะเชื่อมั่นในแชทบอทของเราและใช้บริการของเราเพื่อปกป้องตนเองจากการถูกหลอกลวง',

  addMeiyuQRCode: require('./assets/add-meiyu-qrcode.th.svg'),
  addMeiyuQRCodeAlt: 'เพิ่มเพื่อนบน LINE',
  addMeiyuBtn: 'คลิกและ\nเพิ่มเพื่อนบน\nLINE',
  addMeiyuHref: 'https://line.me/R/ti/p/%40maeroodee',
  addMeiyuAlt: 'เพิ่มเพื่อนบน LINE',
  poweredByGogolook: 'สนับสนุนโดย Gogolook',

  // links will be hidden if href is '#'
  copyright: '© 2022 Gogolook. All Rights Reserved.',
  privacyPolicy: '隱私權政策',
  privacyPolicyHref: '#',
  termsOfService: '服務條款',
  termsOfServiceHref: '#',
  followUs: 'Follow us:',
  followUsLineHref:
    'https://line.me/R/ti/p/%40maeroodee',
  followUsLineAlt: 'Line',
  followUsFacebookHref: '#',
  followUsFacebookAlt: 'Facebook',
  followUsTwitterHref: '#',
  followUsTwitterAlt: 'Twitter',
};
